import React from 'react';
import { Phone, Mail, Instagram, Facebook, ArrowUp, MapPin } from 'lucide-react';
import { companyInfo, navLinks } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-brand-dark pt-16 pb-8">
      <div className="container mx-auto px-4">
        {/* CTA Section */}
        <div className="bg-brand-primary rounded-[32px] p-8 md:p-12 mb-16 text-center">
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-brand-dark mb-4">
            Ready to Transform Your Outdoor Space?
          </h3>
          <p className="text-brand-dark/80 text-lg mb-8 max-w-2xl mx-auto">
            Call now for a free estimate! Let's bring your landscaping vision
            to life.
          </p>
          <a
            href={`tel:${companyInfo.phone}`}
            className="inline-flex items-center gap-3 bg-brand-dark text-white hover:bg-brand-hover rounded-full px-8 py-4 text-xl font-bold transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <Phone size={24} />
            {companyInfo.phone}
          </a>
        </div>

        {/* Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/cw3pso9x_PHOTO-2026-01-26-12-34-00.jpeg" 
                alt="TWINS LAWN & LANDSCAPE LLC"
                className="h-16 w-auto rounded-xl"
              />
            </div>
            <p className="text-white/70 leading-relaxed mb-6 max-w-md">
              Professional lawn care and landscaping services you can trust.
              Serving residential and commercial properties with dedication,
              quality craftsmanship, and attention to detail.
            </p>
            <div className="flex gap-4">
              <a
                href={companyInfo.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-brand-primary rounded-full flex items-center justify-center text-white hover:text-brand-dark transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href={companyInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-brand-primary rounded-full flex items-center justify-center text-white hover:text-brand-dark transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-white/70 hover:text-brand-primary transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center gap-3 text-white/70 hover:text-brand-primary transition-colors"
                >
                  <Phone size={18} />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-white/70 hover:text-brand-primary transition-colors"
                >
                  <Mail size={18} />
                  {companyInfo.email}
                </a>
              </li>
              <li>
                <div className="flex items-center gap-3 text-white/70">
                  <MapPin size={18} />
                  {companyInfo.location}
                </div>
              </li>
              <li>
                <a
                  href={companyInfo.facebookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-brand-primary transition-colors"
                >
                  <Facebook size={18} />
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href={companyInfo.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-brand-primary transition-colors"
                >
                  <Instagram size={18} />
                  {companyInfo.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm text-center md:text-left">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="w-10 h-10 bg-white/10 hover:bg-brand-primary rounded-full flex items-center justify-center text-white hover:text-brand-dark transition-all duration-300"
            aria-label="Scroll to top"
          >
            <ArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
